import { useEffect, useRef, useState } from "react";
import Image from "components/Elements/Image/Image";
import useMediaQueries from "hooks/useMediaQueries";

const SecuritySection = () => {
  const [containerHeight, setContainerHeight] = useState(0);
  const { mobileCondition } = useMediaQueries();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      setContainerHeight(ref.current.parentElement?.clientHeight || 0);
    }
  }, [ref.current]);

  return (
    <div
      className="col-5 security-section"
      ref={ref}
      style={
        mobileCondition
          ? {}
          : {
              height: containerHeight > 0 ? containerHeight - 120 : "auto",
            }
      }
    >
      <Image
        name="business/security-bg-circle"
        ext="png"
        id="business-security-bg-circle"
      />
      <Image name="business/soc_1" ext="png" id="business-soc_1" />
      <Image name="business/soc_2" ext="png" id="business-soc_2" />
      <Image name="business/soc_3" ext="png" id="business-soc_3" />
      <Image name="business/soc_4" ext="png" id="business-soc_4" />
    </div>
  );
};

export default SecuritySection;
